import * as THREE from 'three';
import React, { useRef } from 'react';
import { Canvas, extend, useFrame, useThree } from '@react-three/fiber';
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { OrbitControls } from '../OrbitControls/OrbitControls';

// /* eslint-disable */
// import React, { forwardRef, ForwardedRef, MutableRefObject, useEffect, useRef } from 'react';
// import {
// 	MOUSE,
// 	Vector2,
// 	Vector3,
// 	Vector4,
// 	Quaternion,
// 	Matrix4,
// 	Spherical,
// 	Box3,
// 	Sphere,
// 	Raycaster,
// 	MathUtils,
// } from 'three';
// import { ReactThreeFiber, extend, useFrame, useThree } from '@react-three/fiber';
// import CameraControlsDefault from 'camera-controls';

// declare global {
// 	namespace JSX {
// 		interface IntrinsicElements {
// 			cameraControlsDefault: ReactThreeFiber.Node<CameraControlsDefault, typeof CameraControlsDefault>;
// 		}
// 	}
// }

// const subsetOfTHREE = {
// 	MOUSE: MOUSE,
// 	Vector2: Vector2,
// 	Vector3: Vector3,
// 	Vector4: Vector4,
// 	Quaternion: Quaternion,
// 	Matrix4: Matrix4,
// 	Spherical: Spherical,
// 	Box3: Box3,
// 	Sphere: Sphere,
// 	Raycaster: Raycaster,
// 	MathUtils: {
// 		DEG2RAD: MathUtils.DEG2RAD,
// 		clamp: MathUtils.clamp,
// 	},
// };

// CameraControlsDefault.install({ THREE: subsetOfTHREE });
// extend({ CameraControlsDefault });

// export const CameraControls = forwardRef<CameraControlsDefault, unknown>((_, ref) => {
// 	const cameraControls = useRef<CameraControlsDefault | null>(null);
// 	const camera = useThree((state) => state.camera);
// 	const renderer = useThree((state) => state.gl);
// 	useFrame((_, delta) => cameraControls.current?.update(delta));
// 	useEffect(() => () => cameraControls.current?.dispose(), []);
// 	return (
// 		<cameraControlsDefault
// 			ref={mergeRefs<CameraControlsDefault>(cameraControls, ref)}
// 			args={[camera, renderer.domElement]}
// 		/>
// 	);
// });

// export type CameraControls = CameraControlsDefault;

// function mergeRefs<T>(...refs: (MutableRefObject<T> | ForwardedRef<T>)[]) {
// 	return (instance: T): void => {
// 		for (const ref of refs) {
// 			if (typeof ref === 'function') {
// 				ref(instance);
// 			} else if (ref) {
// 				ref.current = instance;
// 			}
// 		}
// 	};
// }

extend({OrbitControls});
function CameraControls() {
    // Get a reference to the Three.js Camera, and the canvas html element.
    // We need these to setup the OrbitControls component.
    // https://threejs.org/docs/#examples/en/controls/OrbitControls
    const {
        camera,
        gl: { domElement },
    } = useThree();
    // Ref to the controls, so that we can update them on every frame using useFrame
    const controls = useRef();
    useFrame((state) => controls.current.update());
    return <orbitControls ref={controls} args={[camera, domElement]} />;
};
export default CameraControls;